import styled from "@emotion/styled";
import {
  Button as LoadingButton,
  Accordion,
  AccordionSummary,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import theme from "../theme";

export const AddMemberTabs = styled(Tabs)`
  min-height: 68px;
  border-bottom: 1px solid ${theme.palette.divider};
`;

export const ChipsWrapper = styled(Box)`
  padding: 5px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-top: 1px solid ${theme.palette.grey[300]};
  overflow: auto;
  height: 100px;
`;

export const AddedMembersContainer = styled(Box)`
  width: 100%;
  bottom: 0;
`;

export const ChipsContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const ButtonWrapper = styled(Box)`
  padding: 10px;
  background: ${theme.palette.grey[200]};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${theme.palette.divider};
`;

export const AddMemberButton = styled(LoadingButton)`
  width: 140px;
`;

export const AddUserListContainer = styled(Box)`
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const UserListItem = styled(ListItem)`
  flex-direction: column;
  align-items: flex-start;
  padding: 0 10px 10px 10px;
`;

export const UserButton = styled(ListItemButton)`
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  cursor: auto;
  border: 1px solid ${theme.palette.grey[300]};
  padding: 10px 16px 10px 16px;
  margin-bottom: 2px;
  border-radius: 4px;

  &:hover {
    background: none;
  }
`;

export const AddedUserCard = styled(Box)`
  display: flex;
  align-items: center;
  height: 56px;
`;

export const UserAvatar = styled(ListItemAvatar)`
  min-width: 0;
  margin-right: 8px;
`;

export const ReferralTextField = styled(TextField)`
  margin-top: 10px;
`;

export const ButtonsWrapper = styled(Box)`
  margin-top: 8px;
  display: flex;
  width: 100%;
  gap: 15px;
`;

export const AddGroupListContainer = styled(Box)`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const AddMemberTabsContainer = styled(Box)`
  overflow-y: auto;
  height: 100%;
`;

export const SearchAndFilterContainer = styled(Box)`
  margin: 10px 10px 0 10px;
`;

export const AccordionContainer = styled(Accordion)`
  align-items: center;
  width: 100%;
  box-shadow: none;
  margin: 0 !important;
  background: transparent;
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0;
  min-height: 0 !important;
  margin: 0 !important;

  & > :first-of-type {
    margin: 0 !important;
  }
  & .MuiAccordionSummary-content {
    flex-direction: column;
  }
`;

export const AccordionDetails = styled(Accordion)`
  padding: 0;
  box-shadow: none;
  background: transparent;
`;

export const PatientsNearbyDetailsWrapper = styled(Box)`
  display: flex;
  gap: 10px;
  padding: 6px 0;
`;

export const PatientsNearby = styled(Typography)`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: ${theme.palette.grey[800]};
`;

export const ClosestPatient = styled(Typography)`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: ${theme.palette.grey[800]};
`;
